module.exports = __webpack_public_path__ + "images/emoji/smile.67ee60a3c063436a133b.png";